export const iconFontAwesomeCodingKeyboard = (
	<i className="fa-solid fa-keyboard"></i>
);
